export default __webpack_public_path__ + "static/media/photo-library-colored.2594f5b2.svg";